import { Component, OnDestroy, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { Subscription } from "rxjs"
import { InstitutionService } from "src/app/shared/services/institution.service"
import { ThemeColor, ThemeService } from "src/app/shared/services/theme/theme.service"

@Component({
  selector: "app-idle",
  templateUrl: "./idle.component.html",
  styleUrls: ["./idle.component.scss"]
})

export class IdleComponent implements OnDestroy {
  subscriptions: Subscription = new Subscription()


  constructor(
    private router: Router,
    private institutionService: InstitutionService,
    private themeService: ThemeService
  ) { /* do nothing */ }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  public goToHomePage(): void {
    this.router.navigate(["home"])
  }
}
